import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos <span className="text-blue-600">coordonnées</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Contactez-nous directement par téléphone ou email pour toute demande de devis ou information
          </p>
        </div>

        {/* Coordonnées Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <Card className="border-gray-200 hover:border-blue-600 transition-colors">
            <CardContent className="p-8">
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 rounded-full p-3 flex-shrink-0">
                  <Phone className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-2 text-lg">Téléphone</p>
                  <a href="tel:0608937844" className="text-blue-600 hover:text-blue-700 font-medium text-xl">
                    06 08 93 78 44
                  </a>
                  <p className="text-sm text-gray-500 mt-2">
                    Réponse sous 24h • Devis gratuit
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-gray-200 hover:border-blue-600 transition-colors">
            <CardContent className="p-8">
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 rounded-full p-3 flex-shrink-0">
                  <Mail className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-2 text-lg">Email</p>
                  <a href="mailto:franckcuriotti_carrelage@yahoo.fr" className="text-blue-600 hover:text-blue-700 font-medium break-all">
                    franckcuriotti_carrelage@yahoo.fr
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-gray-200 hover:border-blue-600 transition-colors">
            <CardContent className="p-8">
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 rounded-full p-3 flex-shrink-0">
                  <MapPin className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-2 text-lg">Adresse</p>
                  <p className="text-gray-600 leading-relaxed">
                    122 route départementale 24<br />
                    69690 Saint-Julien-sur-Bibost<br />
                    France
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-gray-200 hover:border-blue-600 transition-colors">
            <CardContent className="p-8">
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 rounded-full p-3 flex-shrink-0">
                  <Clock className="w-6 h-6 text-blue-600" />
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-gray-900 mb-3 text-lg">Horaires</p>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Lundi - Vendredi</span>
                      <span className="font-medium text-gray-900">08:00 - 19:00</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Samedi</span>
                      <span className="font-medium text-gray-900">08:00 - 12:00</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Dimanche</span>
                      <span className="font-medium text-red-600">Fermé</span>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Info supplémentaire */}
        <div className="mt-12 text-center">
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-6 max-w-2xl mx-auto">
            <p className="text-gray-700 leading-relaxed">
              <strong className="text-gray-900">Zone d'intervention :</strong> 50 km autour de Saint-Julien-sur-Bibost
              <br />
              <span className="text-sm text-gray-600">Lyon • Brignais • Monts du Lyonnais • L'Arbresle • Tarare</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
